export const productTracker = {
  actions: {
    showTechnicalData: 'Produto: Ver dados técnicos',
  },
}
